import * as React from 'react';
import * as cx from 'classnames';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import { PilotAssignments, AssignmentSlotViewModel, PilotGroupingViewModel, PilotViewModel } from './pilotassignments';

export const PilotAssignmentsView = SuperCritical(({ model: m } : { model : PilotAssignments }) =>
    m.Model.CanViewFullPilotAssignments() ?
        <div className="details-section pilot-assignments">
            <div className="details-section-header">
                <span className="details-section-title">Pilot Assignments</span>
            </div>
            <div className="details-section-body">
                {m.AssignmentSlots().map(s =>
                    <AssignmentSlotView slot={s} model={m} key={s.ReactKey} />
                )}
                <div className="add-pilot-container">
                    {m.CanEditPilotAssignments() &&
                        <a href="" onClick={noDefault(m.AddAssignmentSlot)}>+ Assign Pilot</a>
                    }
                </div>
            </div>
        </div> : null
);

let AssignmentSlotView = SuperCritical(({ slot: s, model: m } : { slot : AssignmentSlotViewModel, model : PilotAssignments }) =>
    <div className="pilot-assignment">
        <label className="pilot-assignment-label pc-text-smalllabel">Pilot</label>
        {' '}
        {m.CanEditPilotAssignments() ?
            <AssignmentSlotEditView slot={s} model={m} /> :
            <AssignmentSlotReadonlyView slot={s} />
        }
    </div>
);

let AssignmentSlotEditView = SuperCritical(({ slot: s, model: m } : { slot : AssignmentSlotViewModel, model : PilotAssignments }) =>
    <span>
        <PilotSelector slot={s} model={m} />
        {' '}
        <AssignmentConfirmationView slot={s} />
        {' '}
        <i className="delete-pilot-assignment undo-btn icon-undo-circle" onClick={s.Delete}></i>
    </span>
);

let PilotSelector = SuperCritical(({ slot: s, model: m } : { slot : AssignmentSlotViewModel, model : PilotAssignments }) =>
    <span>
        <select className="pc-select pilot-name pilot-select pjo-select"
            value={s.Model.PilotId()}
            onChange={e => s.Model.PilotId(+e.currentTarget.value)}>
            <option value={0}>--</option>
            {m.PilotSections().filter(ps => m.AnyAssignablePilots(ps, s)).map(ps =>
                <PilotsOptGroup group={ps}
                    label={ps.Model.Name}
                    slot={s}
                    model={m}
                    key={ps.Model.Id()} />
            )}
            {m.AnyAssignablePilots(m.UnassignedPilotSection, s) &&
                <PilotsOptGroup group={m.UnassignedPilotSection}
                    label={() => 'Unassigned'}
                    slot={s}
                    model={m} />
            }
        </select>
        <span className="pc-select-chevron"></span>
    </span>
);

let PilotsOptGroup = SuperCritical(({ group: g, label, slot: s, model: m } : {
    group : PilotGroupingViewModel,
    label : () => string,
    slot : AssignmentSlotViewModel,
    model : PilotAssignments
}) =>
    <optgroup label={label()}>
        {g.Pilots().filter(p => m.PilotAssignableForSlot(p, s)).map(p =>
            <PilotOption pilot={p} key={p.Model.Id()} />
        )}
    </optgroup>
);

let PilotOption = SuperCritical(({ pilot: p } : { pilot : PilotViewModel }) =>
    <option value={p.Model.Id()}>{p.DisplayName()}</option>
);

let AssignmentSlotReadonlyView = SuperCritical(({ slot: s } : { slot : AssignmentSlotViewModel }) =>
    <span>
        <span className="pilot-name pilot-name-view-only">
            {s.Pilot() && s.Pilot()!.DisplayName()}
        </span>
        {' '}
        <AssignmentConfirmationView slot={s} readonly />
    </span>
);

let AssignmentConfirmationView = SuperCritical(({ slot: s, readonly } : { slot : AssignmentSlotViewModel, readonly? : boolean }) => {
    if (!s.Model.PilotId()) return null;
    const className=cx('pjo-details-confirmation', {
            'pjo-details-confirmed': s.Model.PilotConfirmed()
        }),
        confirmationText = s.Model.PilotConfirmed() ? 'Confirmed' : 'Tentative';

    return readonly ?
        <span className={className}>{confirmationText}</span> :
        <a href="" className={className} onClick={noDefault(() => s.Model.PilotConfirmed(!s.Model.PilotConfirmed()))}>
            {confirmationText}
        </a>;
});


// WEBPACK FOOTER //
// ./apps/pilots/pilotjoborderdetails/pilotassignmentsview.tsx